import React, { createContext, useState, useEffect } from 'react';

const UserContext = createContext(null);

function UserProvider({ children }) {
  // const [userData, setUserData] = useState(null);

  // useEffect(() => {
  //   // Recupera i dati dell'utente dal localStorage al caricamento
  //   const storedUser = localStorage.getItem('user');
  //   if (storedUser) {
  //     setUserData(JSON.parse(storedUser));
  //   }
  // }, []);
  const [userData, setUserData] = useState(() => {
    try {
      const storedUser = localStorage.getItem('user');
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Errore nel parsing dell'utente da localStorage:", error);
      return null;
    }
  });

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {children}
    </UserContext.Provider>
  );
}

export { UserContext, UserProvider };